/**
 * Helper functions for route handling in the settings page
 */

/**
 * Categorizes routes into submenu and non-submenu routes and checks if current path matches a non-submenu route
 * @param routes Array of route objects with isSubMenuRoute property
 * @param currentPath Current path from location
 * @returns Object with categorized routes and flag indicating if current path is a non-submenu route
 */
export const categorizeRoutes = (routes: any[], currentPath: string) => {
  return routes.reduce(
    (acc, route) => {
      // Categorize the route
      if (route.isSubMenuRoute) {
        acc.submenuRoutes.push(route)
      } else {
        acc.nonSubmenuRoutes.push(route)
        // More precise path matching using regex pattern
        // Handle dynamic params in route.path (e.g., createSupervision/:templateId?)
        // Convert ':param' -> "[^/]+" and ':param?' -> "(?:/[^/]+)?" (including the slash)
        const routePathRegexFragment = String(route.path)
          // optional param with preceding slash
          .replace(/\/:([^/]+)\?/g, '(?:/[^/]+)?')
          // required param with preceding slash
          .replace(/\/:([^/]+)/g, '/[^/]+')
        // Match /settings/<fragment> exactly or with trailing slash or query params
        const routePathPattern = new RegExp(`/settings/${routePathRegexFragment}(?:/|$|\\?)`)
        if (routePathPattern.test(currentPath)) {
          acc.isNonSubmenuRoute = true
        }
      }
      return acc
    },
    { submenuRoutes: [], nonSubmenuRoutes: [], isNonSubmenuRoute: false } as {
      submenuRoutes: any[]
      nonSubmenuRoutes: any[]
      isNonSubmenuRoute: boolean
    },
  )
}
